import { http } from '@frontend/fetch';
import { addLocationHeader } from '../utils/add-location-header';

export type DetachPaymentMethodProps = {
  paymentMethodId: string;
  locationId: string | undefined;
};
export type DetachPaymentMethodResponse = void;

export const detachPaymentMethod = async ({ paymentMethodId, locationId }: DetachPaymentMethodProps) =>
  await http.delete<DetachPaymentMethodResponse>(
    `payments/paymentMethods/${paymentMethodId}`,
    {},
    addLocationHeader(locationId ?? '')
  );
